import { css } from '@emotion/react';

import { mobileOnly, tabletUp } from 'styles/utils';

export const rootBaseCss = css`
  display: grid;
  grid-row-gap: 13px;

  ${mobileOnly} {
    grid-template-areas: 'title' 'promos' 'ctaLink';
  }

  ${tabletUp} {
    grid-template-columns: 2fr 1fr;
    grid-template-areas: 'title ctaLink' 'promos promos';
  }
`;

export const titleBaseCss = css`
  grid-area: title;
  align-self: center;
  letter-spacing: 1.75px;
`;

export const ctaBaseCss = css`
  grid-area: ctaLink;

  ${mobileOnly} {
    margin-top: 10px;
  }

  ${tabletUp} {
    display: inline-flex;
    justify-content: flex-end;
  }
`;

export const promosBaseCss = css`
  display: grid;
  grid-area: promos;
  grid-column-gap: 12px;

  ${tabletUp} {
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 37px;
  }

  ${mobileOnly} {
    grid-template-columns: 1fr;
    grid-row-gap: 12px;
  }
`;
